var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { layout, space, typography } from 'styled-system';
import { colors } from "../styles";
import theme from "../styles/theme";
import { css, mq, styled } from "../utils";
var textAlignToLinePosition = {
    center: {
        left: 'auto',
        right: 'auto',
    },
    left: {
        left: 'unset',
        right: 'auto',
    },
    right: {
        left: 'auto',
        right: 'unset',
    },
};
var convertTextAlignToLinePosition = function (arg) {
    if (!arg)
        return 'margin-right: auto;';
    if (!Array.isArray(arg)) {
        return mq({
            marginLeft: textAlignToLinePosition[arg].left || 'unset',
            marginRight: textAlignToLinePosition[arg].right || 'unset',
        });
    }
    return mq({
        marginLeft: arg.map(function (value) { return textAlignToLinePosition[value].left || 'unset'; }),
        marginRight: arg.map(function (value) { return textAlignToLinePosition[value].right || 'unset'; }),
    });
};
var lineStyles = function (textAlign, color, defaultColor) { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ::before {\n    content: '';\n    display: block;\n    width: 91px;\n    height: 3px;\n    margin-bottom: 8px;\n    background: ", ";\n    ", ";\n  }\n"], ["\n  ::before {\n    content: '';\n    display: block;\n    width: 91px;\n    height: 3px;\n    margin-bottom: 8px;\n    background: ", ";\n    ", ";\n  }\n"])), color || defaultColor, convertTextAlignToLinePosition(textAlign)); };
var Heading = function (key) {
    return styled(key)(function (_a) {
        var _b = _a.theme, headings = _b.components.headings, fonts = _b.fonts, withLine = _a.withLine, textAlign = _a.textAlign, _c = _a.color, color = _c === void 0 ? colors.primary : _c;
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      && {\n        color: ", ";\n        font-family: ", ";\n      }\n      ", "\n      ", ";\n\n      strong {\n        font-family: ", ";\n        font-weight: ", ";\n      }\n    "], ["\n      && {\n        color: ", ";\n        font-family: ", ";\n      }\n      ", "\n      ", ";\n\n      strong {\n        font-family: ", ";\n        font-weight: ", ";\n      }\n    "])), color, fonts.tertiary, withLine && lineStyles(textAlign, color, colors.primary), mq(headings[key]), theme.fonts.tertiary, theme.fontWeights.extraBold);
    }, typography, space, layout);
};
export default {
    Heading1: Heading('h1'),
    Heading2: Heading('h2'),
    Heading3: Heading('h3'),
    Heading4: Heading('h4'),
    Heading5: Heading('h5'),
    Heading6: Heading('h6'),
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Heading.js.map